import Error from 'next/error'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { BuilderComponent, builder } from '@builder.io/react'
import { HEADER, TRANSLATIONS } from '../util/constants'
import Layout from '../components/layout'
import { Seo } from '../components/seo'

export default function Landlords({ data, builderJson }) {
	if (!data) return <Error statusCode={404} />

	return (
		<Layout site={data.site} showFooter={true} headerType={HEADER.withNav}>
			<Seo route={data.route} site={data.site} />
			<BuilderComponent model='landlord' content={builderJson} />
		</Layout>
	)
}
export async function getStaticProps({ locale }) {
	const pageData = {}
	const builderJson = await builder
		.get('landlord', { userAttributes: { urlPath: '/landlord' } })
		.toPromise()

	return {
		props: {
			builderJson: builderJson || null,
			...(await serverSideTranslations(locale, TRANSLATIONS)),
			data: {
				page: pageData,
				route: {
					openGraph: {
						title: 'Landlord',
						description: 'Stuf Storage Landlord'
					}
				},
				site: {
					openGraph: {
						description: ''
					}
				}
			}
		},
		revalidate: 1
	}
}
